import { IResolve } from '@/types/communal.types';
import {
  IAccountListResolve,
  IAddAccountResolve,
  IAddUserRolesParams,
  ICreateOrganizationAccountParams,
  IEditAccountResolve,
  IEditOrganizationAccountParams,
  IEditUserRolesParams,
  ILoadAccountListParams,
  IRemoveUserRolesParams,
  IResetPasswordParams,
  IUpdateStatus,
} from '../../types/accounts.types';
import { api } from './api';
import { ITableList } from './role/types';
import { emojiToHtmlEntity } from '@/utils/format';
import { IApplyParams } from '@/types/auditRecord.types';

export const getOrganizationUsers = async (params: ILoadAccountListParams): Promise<IAccountListResolve> => {
  const res: IAccountListResolve = await api.get('/User/users', { params });
  if (res.Data?.Items?.length > 0) {
    res.Data.Items.forEach(item => {
      if (item.UserName) {
        item.UserName = emojiToHtmlEntity(item.UserName);
      }
    });
  }
  return res;
};
export const createOrganizationUser = async (
  params: ICreateOrganizationAccountParams,
): Promise<IAddAccountResolve> => {
  return await api.post('/User', params);
};
export const editOrganizationUser = async (
  params: IEditOrganizationAccountParams,
): Promise<IEditAccountResolve> => {
  return await api.post('/User/updateAccount', params);
};
export const disableUser = async (userId: string, applyParams: IApplyParams): Promise<IUpdateStatus> => {
  return await api.delete('/User/deleteAccount', {
    data: {
      isActive: false,
      userId,
      ...applyParams,
    },
  });
};
export const enableUser = async (userId: string, applyParams: IApplyParams): Promise<IUpdateStatus> => {
  return await api.post('/User/enableAccount', {
    isActive: true,
    userId,
    ...applyParams,
  });
};
export const addUserRoles = async (params: IAddUserRolesParams): Promise<IResolve<undefined>> => {
  return await api.post('/User/AddUserRoles', params);
};
export const removeUserRoles = async (
  params: IRemoveUserRolesParams,
): Promise<IResolve<undefined>> => {
  return await api.post('/User/deleteUserRole', params);
};
export const getUserRoles = async (userId: string): Promise<IResolve<ITableList>> => {
  return await api.get(`/User/${userId}/getRoleByUserId`);
};
export const resetPassword = async (data: IResetPasswordParams): Promise<IResolve<undefined>> => {
  return await api.post('/User/emailResetPassword', data);
};

/**
 * 编辑用户角色（需审核）
 */
export const editUserRolesApi = (params: IEditUserRolesParams & IApplyParams): Promise<IResolve<string>> => {
  return api.post('/User/EditUserRoles', params);
};

/**
 * 会话心跳：前端在用户活动（鼠标/键盘/滚动等）或定时触发时调用， 用于保持登录 token 生效（滑动续期 15 分钟）。 该请求需携带已登录用户的 Authorization 头；空闲过期后会返回 401/403，前端应据此跳转登录。
 * @returns
 */
export const heartbeatApi = async (): Promise<IResolve<undefined>> => {
  return await api.get('/session/heartbeat');
};
